'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurveyLogo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SurveyLogo, _Component);

  function SurveyLogo(props) {
    (0, _classCallCheck3.default)(this, SurveyLogo);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./SurveyLogo.scss');
    return _this;
  }

  SurveyLogo.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'svg',
        {
          version: '1.0',
          xmlns: 'http://www.w3.org/2000/svg',
          width: '600',
          height: '60',
          className: this.styles.svgStyles
        },
        _react2.default.createElement(
          'g',
          {
            transform: 'translate(0.000000,146.000000) scale(0.100000,-0.100000)',
            fill: this.props.theme,
            stroke: 'none'
          },
          _react2.default.createElement('path', {
            d: 'M0 1390 l0 -70 1853 -2 1852 -3 63 -29 c128 -59 206 -173 315 -466\n72 -191 97 -247 145 -317 77 -114 163 -176 287 -209 41 -11 1127 -14 6318 -14\nl6267 0 0 590 0 590 -8550 0 -8550 0 0 -70z'
          })
        )
      )
    );
  };

  return SurveyLogo;
}(_react.Component), _class.propTypes = {
  colorcode: _react.PropTypes.string,
  theme: _react.PropTypes.object
}, _temp);
exports.default = SurveyLogo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SurveyLogo/SurveyLogo.js
// module id = 2336
// module chunks = 0